var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.$style.label, _vm.$style[("label--" + _vm.state)], ( _obj = {}, _obj[_vm.$style['label--text']] = _vm.text, _obj[_vm.$style['label--dot']] = _vm.dot, _obj[_vm.$style['label--round']] = _vm.round, _obj )]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }